import axios from 'axios';
import { cui, Notification } from 'components';
import { initializeStore } from 'store';
import PubSub from 'pubsub-js';

const https = require('https');
axios.defaults.httpsAgent = new https.Agent({ rejectUnauthorized: false });
axios.defaults.timeout = 30000;

function handleHttpError(error) {
  if (error.response && error.response.data) {
    return error.response.data.errorMessage || error;
  }

  return error;
}

// function serialize(obj) { 
//   const str = [];
//   for (const p in obj) {
//     if (obj.hasOwnProperty(p)) {
//       str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
//     } 
//   }
//   return str.join('&');
// }

function transformConfig(config) {
  const requestTime = Date.now();	
  const headers = {
    'Content-Type': 'application/json',
    RequestTime: requestTime,	
    ...config.headers,
  };

  config.headers = headers;
  config.timeout = 30000;
  return config;
}

function makeHttpRequest(apiCall, successCallBack, failCallBack, transformFunc) {
  const store = initializeStore();
  store.dispatch({ type: 'SHOW_PROGRESS' });
  const state = store.getState();

  return new Promise(async () => {
    try {
      const response = await apiCall();
      store.dispatch({ type: 'HIDE_PROGRESS' });
      const isAuthorized = localStorage.getItem('authorized');
      if ((response?.data?.error_code === '401' || response?.data?.errorCode === '401' || response?.data?.result?.ErrorCode == 404) && state?.authorizedReducer?.authorized && isAuthorized) {
          Notification.error('Phiên làm việc đã hết hạn, Vui lòng đăng nhập lại');
          PubSub.publish("FORCE_LOGIN");
          store.dispatch({ type: 'LOGOUT_ACTION' });        
          localStorage.clear();
          return;
      }
      const responseData = response.data;
      const successResponse = cui.isFunction(transformFunc) ? transformFunc(responseData) : responseData;
      successCallBack(successResponse);
    } catch (e) {
      if (cui.isFunction(failCallBack)) {
        failCallBack(handleHttpError(e));
        store.dispatch({ type: 'HIDE_PROGRESS' });
      }
    }
  });
}

function makeHttpRequestNotLoading(apiCall, successCallBack, failCallBack, transformFunc) {
  const store = initializeStore();
  const state = store.getState();

  return new Promise(async () => {
    try {
      const response = await apiCall();
      const isAuthorized = localStorage.getItem('authorized');
      if ((response?.data?.error_code == '401' || response?.data?.errorCode === '401' || response?.data?.result?.ErrorCode == 404) && state?.authorizedReducer?.authorized && isAuthorized) {
        Notification.error('Phiên làm việc đã hết hạn, Vui lòng đăng nhập lại');
        PubSub.publish("FORCE_LOGIN");
        store.dispatch({ type: 'LOGOUT_ACTION' });        
        localStorage.clear();
        return;
      }
      const responseData = response.data;
      const successResponse = cui.isFunction(transformFunc) ? transformFunc(responseData) : responseData;
      successCallBack(successResponse);
    } catch (e) {
      if (cui.isFunction(failCallBack)) {
        failCallBack(handleHttpError(e));
      }
    }
  });
}

export function getRequest(url, config = {}, successCallBack, failCallBack, transformFunc) {
  transformConfig(config);
  return makeHttpRequest(() => axios.get(url, config), successCallBack, failCallBack, transformFunc);
}

export function postRequest(url, data, config = {}, successCallBack, failCallBack, transformFunc) {
  if (cui.isObject(data)) {
    data.session = localStorage.getItem('session') || '';
  }
  transformConfig(config);
  return makeHttpRequest(() => axios.post(url, data, config), successCallBack, failCallBack, transformFunc);
}

export function postRequestLoyalty(url, data, config = {}, successCallBack, failCallBack, transformFunc) {
  if (cui.isObject(data)) {
    data.session = localStorage.getItem('session') || 'a';
  }
  transformConfig(config);
  return makeHttpRequest(() => axios.post(url, data, config), successCallBack, failCallBack, transformFunc);
}

export function postRequestNoLoading(url, data, config = {}, successCallBack, failCallBack, transformFunc) {
  if (cui.isObject(data)) {
    data.session = localStorage.getItem('session') || '';
  }
  transformConfig(config);
  return makeHttpRequestNotLoading(() => axios.post(url, data, config), successCallBack, failCallBack, transformFunc);
}

export function putRequest(url, data, config = {}, successCallBack, failCallBack) {
  transformConfig(config);
  return makeHttpRequest(() => axios.put(url, data, config), successCallBack, failCallBack);
}

export function deleteRequest(url, data, config = {}, successCallBack, failCallBack) {
  transformConfig(config);
  return makeHttpRequest(() => axios.delete(url, data, config), successCallBack, failCallBack);
}

export function postRequestQrCode(url, data, config = {}, successCallBack, failCallBack, transformFunc) {
  transformConfig(config);
  return makeHttpRequest(() => axios.post(url, data, config), successCallBack, failCallBack, transformFunc);
}

export function postRequestQrCodeNoLoading(url, data, config = {}, successCallBack, failCallBack, transformFunc) {
  transformConfig(config);
  return makeHttpRequestNotLoading(() => axios.post(url, data, config), successCallBack, failCallBack, transformFunc);
}